interface ParsedUrl {
  baseurl: string;
  path: string;
  query: Record<string, string | string[]>;
}

/**
 * 解析URL工具函数
 * @param {string} url
 * @returns {{baseurl: string, path: string, query: object}}
 */
export function parseUrl(url) : ParsedUrl{
  // 1. 提取基础URL (协议+域名+端口)
  const baseUrlMatch = url.match(/^(https?:\/\/[^\/?#]+)/i);
  const baseurl = baseUrlMatch ? baseUrlMatch[0] : '';

  // 2. 提取路径部分
  let path = '';
  if (baseurl) {
    // 有基础URL的情况：移除基础URL后获取路径
    const pathStart = baseurl.length;
    const pathEnd = url.indexOf('?', pathStart);
    path = pathEnd === -1
      ? url.substring(pathStart)
      : url.substring(pathStart, pathEnd);
  } else {
    // 无基础URL的情况（小程序路径）：直接获取问号前的部分
    const pathEnd = url.indexOf('?');
    path = pathEnd === -1 ? url : url.substring(0, pathEnd);
  }

  // 确保路径以斜杠开头（符合小程序规范）
  if (path && !path.startsWith('/')) {
    path = '/' + path;
  }

  // 3. 提取并解析查询参数
  const query = {};
  const queryStart = url.indexOf('?');

  if (queryStart !== -1) {
    const queryString = url.substring(queryStart + 1).split('#')[0];
    const params = queryString.split('&');

    for (const param of params) {
      const [key, value] = param.split('=');
      if (!key) continue;

      const decodedKey = decodeURIComponent(key);
      const decodedValue = value ? decodeURIComponent(value) : '';

      // 处理重复参数（转换为数组）
      if (query.hasOwnProperty(decodedKey)) {
        query[decodedKey] = Array.isArray(query[decodedKey])
          ? [...query[decodedKey], decodedValue]
          : [query[decodedKey], decodedValue];
      } else {
        query[decodedKey] = decodedValue;
      }
    }
  }

  return { baseurl, path, query };
}
